<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="header-toggle">
          <div v-for="(item,index) in tab" :key="index" :class="[index == active ? 'tabActive' : 'noActive']" @click="tabClick(index)">{{item}}</div>
        </div>
        <div class="member-head moneys" style="padding: 0 20px;" v-if="!mobileLoginIn && !$store.getters.ShopInfo.shopBizConfig.easyStaffFlag">
          <div class="member_bg">
            <div class="flex-row">
              *身份证号码注册的用户，提交资料后请先联系运营人员激活该账号，才可以进行交易；
            </div>
          </div>
        </div>
        <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            v-if="mobileLoginIn"
            class="mobile-ruleForm card-ruleForm"
            label-width="180px"
            label-position="left"
          >
            <div class=" head-img">
              <div class="top-img">
                <imgUploadHead @file="getFile" :fileList="form.headImgUrl" module="head" :show="true"></imgUploadHead>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="nickName"
                  label="姓名"
                  prop="nickName"
                  :rules="$rules.required"
                >
                  <el-input v-model.trim="form.nickName" maxlength="10" placeholder="请输入会员姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="gender"
                  label="性别"
                  prop="gender"
                  :rules="$rules.required"
                >
                  <el-select v-model="form.gender" placeholder="请选择" class="w100b">
                    <el-option label="男" value="male"></el-option>
                    <el-option label="女" value="female"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="password"
                  label="密码"
                  prop="password"
                  :rules="$rules.required"
                >
                  <el-input type="password" v-model="form.password" maxlength="6" placeholder="请输入密码" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="comfirmPassword"
                  label="确认密码"
                  prop="comfirmPassword"
                  :rules="$rules.required"
                >
                  <el-input type="password" v-model="form.comfirmPassword" maxlength="6" placeholder="请再次输入密码" @blur="comfirmPsd"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="mobile"
                  label="手机号码"
                  prop="mobile"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.mobile"  maxlength="11" placeholder="请输入电话号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="verifyCode"
                  label="验证码"
                  prop="verifyCode"
                  :rules="$rules.required"
                  v-if="verificationCodeFlag"
                >
                  <div class="smsCode">
                    <el-input placeholder="输入验证码" v-model="form.verifyCode" maxlength="6"></el-input>
                    <div class="sms">
                      <el-divider direction="vertical"></el-divider>
                      <div v-if="!codeName">{{ codeName ? '发送验证码':time+'s'}}</div>
                      <div @click="addLoginCode" v-else>{{ codeName ? '发送验证码':time+'s'}}</div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="birthday"
                  label="会员生日"
                  prop="birthday"
                >
                  <el-date-picker
                    v-model="form.birthday"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    class="w100b"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="idCardNo"
                  label="身份证号码"
                  prop="idCardNo"
                >
                  <el-input v-model="form.idCardNo"  maxlength="18" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="memberRemark"
                  label="备注标签"
                  prop="memberRemark"
                >
                  <el-input v-model="form.memberRemark"  maxlength="10" placeholder="请输入备注标签"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>免密支付</i></p>
            <el-form-item
              label="是否开启小额免密支付"
            >
              <el-switch v-model="tradeNoFlag"></el-switch>
            </el-form-item>
            
            <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>证件上传</i></p>    
            <div v-if="toggleHide" class="item-cards">
              <div class="idcard">
                <div class="front card-box">
                  <imgUpload @file="getFileCardFront" :fileList="idCardFrontUrl" module="idcard"></imgUpload>
                  <p>身份证正面照</p>
                </div>
                <div class="back card-box">
                  <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="idcard"></imgUpload>
                  <p>身份证反面照</p>
                </div>
              </div>
            </div>
            
          </el-form>
          <el-form
            ref="form"
            :model="form"
            v-else
            class="card-ruleForm"
            label-width="104px"
            label-position="left"
          >
            <div class="head-img">
              <div class="top-img">
                <imgUploadHead @file="getFile" :fileList="form.headImgUrl" module="head" :show="true"></imgUploadHead>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="nickName"
                  label="姓名"
                  prop="nickName"
                  :rules="$rules.required"
                >
                  <el-input v-model.trim="form.nickName" maxlength="10" placeholder="请输入会员姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  v-if="!toggleHide"
                  class="el-form-item-update"
                  ref="mobile"
                  label="手机号码"
                  prop="mobile"
                  :rules="$rules.required"
                >
                  <el-input
                    :disabled="form.id != ''?true:false"
                    v-model="form.mobile"
                    maxlength="11"
                    placeholder="请输入电话号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  v-if="!toggleHide"
                  class="el-form-item-update"
                  ref="verifyCode"
                  label="验证码"
                  prop="verifyCode"
                  :rules="$rules.required"
                >
                  <div class="flex-row" style="display: flex;align-items: center;">
                    <el-input placeholder="输入验证码" maxlength="6" v-model="form.verifyCode"></el-input>
                    <el-button
                      style="width: 100px;"
                      type="primary"
                      class="small-btn"
                      @click="addLoginCode"
                      :disabled="!codeName"
                    >{{ codeName ? '发送验证码':time+'s'}}</el-button>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="gender"
                  label="性别"
                  prop="gender"
                  :rules="$rules.required"
                >
                  <el-select v-model="form.gender" placeholder="请选择">
                    <el-option label="男" value="male"></el-option>
                    <el-option label="女" value="female"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  v-if="toggleHide"
                  class="el-form-item-update"
                  ref="password"
                  label="密码"
                  prop="password"
                  :rules="$rules.required"
                >
                  <el-input type="password" v-model="form.password" placeholder="请输入密码" maxlength="6" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="comfirmPassword"
                  label="确认密码"
                  prop="comfirmPassword"
                  :rules="$rules.required"
                >
                  <el-input type="password" v-model="form.comfirmPassword" maxlength="6" placeholder="请再次输入密码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="idCardNo"
                  label="身份证号码"
                  prop="idCardNo"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.idCardNo" placeholder="请输入身份证号码" maxlength="18"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="memberRemark"
                  label="备注标签"
                  prop="memberRemark"
                >
                  <el-input v-model="form.memberRemark"  maxlength="10" placeholder="请输入备注标签"></el-input>
                </el-form-item>
              </el-col>
			  <el-col :span="12">
				  <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>免密支付</i></p>
				  <el-form-item label="是否开启小额免密支付" label-width="180px;">
				    <el-switch v-model="tradeNoFlag"></el-switch>
				  </el-form-item>
			  </el-col>
            </el-row>
            <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>证件上传</i></p> 
            <div v-if="toggleHide" class="item-cards">
              <div class="idcard">
                <div class="front card-box">
                  <imgUpload @file="getFileCardFront" :fileList="idCardFrontUrl" module="idcard"></imgUpload>
                  <p><span class="moneys">*</span> 身份证正面照</p>
                </div>
                <div class="back card-box">
                  <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="idcard"></imgUpload>
                  <p><span class="moneys">*</span> 身份证反面照</p>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns" style="display: flex;align-items: center;">
            <el-button type="primary" class="ml10" @click="onSubmit">确定</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import imgUpload from "../../components/common/modules/uploads";
import imgUploadHead from "../../components/common/modules/upload-head";
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload, imgUploadHead },
  props: ["value"],
  data() {
    return {
      mobileLoginIn: true,
      toggleHide: true,
      codeName: true,
      time: 60,
      addEditTitle: "会员管理 > 新增会员",
      addEditShow: false,
      tab: ["手机号注册","身份证注册"],
      active: 0,
      form: {
        id: "",
        gender: "male", //性别,male为男,female为女
        nickName: "", //真实姓名
        mobile: "", //手机号码
        birthday: '', // 会员生日
        idCardNo: "", //身份证号码
        headImgUrl: "", //头像地址
        idCardFrontUrl: "", //身份证正面照片
        idCardBackUrl: "", //身份证反面照片
        tradeNoPwdFlag: "",
        memberRemark: '',
        level: "", //等级 默认0
        password: "", //密码
        verifyCode: '',
        comfirmPassword: "" //确认密码
      },
      idCardFrontUrl: '',
      idCardBackUrl: '',
      tradeNoFlag: false,
      headImgUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      activeNames: ['1'],
      verificationCodeFlag: true
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$refs['form'].resetFields();
      this.tradeNoFlag = false;
      this.$emit("change", false);
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        if (this.value && this.value.length == 11) {
            this.active = 0;
            this.form.mobile = this.value;
            this.mobileLoginIn =  true;
        } else if (this.value && this.value.length == 18) {
            this.active = 1;
            this.form.idCardNo = this.value;
            this.mobileLoginIn =  false;
        } else {
            this.mobileLoginIn = true;
        }
        this.toggleHide = true;
        this.addEditShow = true;
        this.addEditTitle = "注册会员";
        this.getAppInit();
      });
    },
    getAppInit () {
      if (sessionStorage.getItem('appInit')) {
        let appInit = JSON.parse(sessionStorage.getItem('appInit'))
        this.verificationCodeFlag = appInit.configManagerVo.registerMemberManager.verificationCodeFlag || false
      }
    },
    // 上传组件成功回调
    getFile(res) {
      if (!this.form.id && this.form.headImgUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.headImgUrl});
      }
      this.form.headImgUrl = res;
    },
    getFileCardFront(res) {
      //身份证正面
      if (!this.form.id && this.form.idCardFrontUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.idCardFrontUrl});
      }
      this.form.idCardFrontUrl = res.oldImgUrl;
      this.idCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      if (!this.form.id && this.form.idCardBackUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.idCardBackUrl});
      }
      this.form.idCardBackUrl = res.oldImgUrl;
      this.idCardBackUrl = res.newImgUrl;
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.tradeNoFlag = false;
      this.addEditShow = false;
      this.$emit("change", false);
    },
    // 确认密码
    comfirmPsd () {
      if (this.form.comfirmPassword != this.form.password) {
        return this.$message.error("两次密码输入不一致");
      }
    },
    addLoginCode(type) {
      if (this.form.mobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.form.mobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }

      let arr = encrypt(
        JSON.stringify({
          mobile: this.form.mobile,
          bizType: this.toggleHide ? "addmember" : "changeloginpwd",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
          this.codeName = false;
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    onSubmit(values) {
        console.log(this.form)
        if (this.tradeNoFlag) {
            this.form.tradeNoPwdFlag = "on"
        } else {
            this.form.tradeNoPwdFlag = "off"
        }
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (this.form.comfirmPassword != this.form.password) {
            return this.$message.error("两次密码输入不一致");
          }
            if (this.mobileLoginIn) {
              //是否手机号码注册
              if (this.form.idCardNo || this.form.idCardFrontUrl || this.form.idCardBackUrl) {
                if (!this.form.idCardNo) {
                  return this.$message.error("请填写身份证号码");
                } else if (!this.form.idCardFrontUrl && this.form.idCardBackUrl) {
                  return this.$message.error("请上传身份证正面照");
                } else if (this.form.idCardFrontUrl && !this.form.idCardBackUrl) {
                  return this.$message.error("请上传身份证反面照");
                }
              }
              
              this.$api.post(this.$url.member.save, this.form).then(res => {
                  if (res) {
                    this.addEditShow = false;
                    this.$message.success("操作成功");
                    this.$emit("change", true);
                    this.$emit('handChange', this.form.mobile);
                  }
                })
                .catch(error => {});
            } else {
              if (!this.form.idCardFrontUrl) {
                return this.$message.error("请上传身份证正面照");
              } else if (!this.form.idCardBackUrl) {
                return this.$message.error("请上传身份证反面照");
              }
              this.$api.post(this.$url.member.saveByIdCard, this.form).then(res => {
                  if (res) {
                    this.addEditShow = false;
                    this.$message.success("操作成功");
                    this.$emit("change", true);
                    this.$emit('handChange', this.form.mobile);
                  }
                })
                .catch(error => {});
            }
        }
      });
    },
    tabClick (index) {
    console.log(index);
    if (index == 0) {
      this.mobileLoginIn = true;
    } else if (index == 1) {
      this.mobileLoginIn = false;
    }
      this.active = index
      this.$refs['form'].resetFields();
      this.tradeNoFlag = false;
      this.form.gender = 'male';
    //   this.form.tradeNoPwdFlag = false
      this.form.idCardFrontUrl = "";
      this.form.idCardBackUrl = "";
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.header-toggle {
  display: flex;
  height: 32px;
  line-height: 32px;
  margin: 30px 24px;
  border: 1px solid #3388FF;
  border-radius: 2px;
  div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .tabActive {
    background: #3388FF;
    color: #fff;
  }
  .noActive {
    background: #fff;
    color: #3388FF;
  }
}
.head-img {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

.member_bg {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pay-mains {
  padding: 0;

  .card-ruleForm {
    padding-bottom: 0;
    /deep/ .el-form-item {
      padding: 10px 20px;
      margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
    }
    .item-cards {
      padding: 20px;
      .idcard {
        display: flex;
        justify-content: center;
        .card-box {
          p {
            margin-top: 10px;
          }
          text-align: center;
        }
        .back {
          margin-left: 35px;
        }
      }
    }
    .el-form-item-update {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      margin: 0;
      background: #fff;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
      }
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }
    }
    
  }
  .smsCode {
    position: relative;
    
    .sms {
      position: absolute;
      right: 10px;
      bottom: 0;
      cursor: pointer;
      color: #3388FF;
      display: flex;
      align-items: center;
    }
  }
}
</style>